<div #imageContainer [ngStyle]="{ &quot;width&quot;: imgWidth }"><img *ngIf="!loading && src" [src]="dom.bypassSecurityTrustResourceUrl(src)" style="width:inherit" #img/><span style="font-size:0px">{{orientation}}</span></div>
